<template lang='pug'>
section
  v-container(class='pb-0' fluid grid-list-xl)
    v-layout(row wrap)
      v-flex(xs6)
        v-select(
          :items='payments'
          :item-text='selectLabel'
          v-model='id'
          item-value='id'
          label='Выберите договор'
        )
  v-slide-y-transition
    template(v-if='pays.length')
      s-client-payments(:payments='pays')
</template>

<script>
export default {
  props: ['isLoading', 'payments'],

  data: () => ({
    id: null
  }),

  methods: {
    selectLabel(o) {
      return `
        ${o.num},
        ${o.accomodation_type},
        ${o.object_name},
        № ${o.number}
      `
    },
  },

  computed: {
    pays() {
      let payments = this.payments.find(x => x.id == this.id)
      return payments && payments.pays ? payments.pays : []
    }
  }
}
</script>

<style scoped>
.pays-table >>> td {
  border-top: 0;
  border-bottom: solid 1px #c5c5c5;
}
.month-name {
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  background: #fafafa;
  font-weight: 600;
  font-size: 10px;
}
</style>
